import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */

/* eslint-disable jsx-a11y/no-static-element-interactions */
import "rc-tooltip/assets/bootstrap.css";
import { colorsDictionary } from "@temp/@next/utils/colorsDictionary";
import { ConditionalWrapper } from "@temp/@next/utils/ConditionalWrapper";
import { getTextureThumbnailUrl } from "@temp/core/utils";
import upperFirst from "lodash/upperFirst";
import Tooltip from "rc-tooltip";
import React from "react";
import ReactSVG from "react-svg";
import checkImg from "../../../../images/check.svg";
import crossImg from "../../../../images/cross.svg";
import * as S from "./styles";
var ENTER_KEY = 13;
var SPACE_KEY = 32;
export var SquareColorCheckbox = function SquareColorCheckbox(_ref) {
  var _value$translation2;

  var name = _ref.name,
      checked = _ref.checked,
      value = _ref.value,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      _ref$tooltip = _ref.tooltip,
      tooltip = _ref$tooltip === void 0 ? false : _ref$tooltip,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      props = _objectWithoutProperties(_ref, ["name", "checked", "value", "onChange", "onMouseEnter", "onMouseLeave", "tooltip", "disabled"]);

  var ref = React.useRef(null);
  return React.createElement(S.ColorCheckbox, {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    ref: ref,
    onClick: function onClick(evt) {
      if (disabled) {
        return;
      }

      evt.preventDefault();
      onChange(evt);

      if (ref.current) {
        ref.current.blur();
      }
    }
  }, React.createElement(S.Label, {
    disabled: disabled
  }, React.createElement("input", _extends({}, props, {
    tabIndex: -1,
    type: "checkbox",
    name: name,
    checked: checked,
    readOnly: true
  })), React.createElement("div", {
    ref: ref,
    tabIndex: 0,
    onKeyDown: function onKeyDown(evt) {
      if (disabled) {
        return;
      }

      if (evt.which === SPACE_KEY || evt.which === ENTER_KEY) {
        evt.preventDefault();
        onChange(evt);
      }
    }
  }, React.createElement(ConditionalWrapper, {
    condition: tooltip,
    wrapper: function wrapper(children) {
      var _value$translation;

      return React.createElement(Tooltip, {
        overlayInnerStyle: {
          backgroundColor: "rgba(44, 44, 44, 1)"
        },
        placement: "top",
        overlay: ((_value$translation = value.translation) === null || _value$translation === void 0 ? void 0 : _value$translation.name) || value.name
      }, children);
    }
  }, React.createElement("span", {
    style: {
      backgroundColor: value.color || colorsDictionary[value.slug],
      backgroundImage: "url(".concat(getTextureThumbnailUrl(value.slug), ")")
    }
  }, React.createElement(ReactSVG, {
    path: checkImg,
    className: "color-checkbox__icon-check"
  }), React.createElement(ReactSVG, {
    path: crossImg,
    className: "color-checkbox__icon-cross"
  })))), React.createElement(S.Name, {
    disabled: disabled,
    checked: checked
  }, upperFirst(((_value$translation2 = value.translation) === null || _value$translation2 === void 0 ? void 0 : _value$translation2.name) || value.name).replace("_", " "))));
};
SquareColorCheckbox.displayName = "ColorSquareCheckbox";